import { useEffect, useMemo, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useKiosk } from "./KioskContext";
import { OfferCardView } from "./OfferCardView";

export const OfferCard = ({ modelSlug, inline = false }) => {
  const { data, tx, t, logPlay, online } = useKiosk();
  const offers = useMemo(
    () => data.offers.filter((o) => !o.model_slug || o.model_slug === modelSlug).sort((a, b) => (b.published_at || "").localeCompare(a.published_at || "")),
    [data.offers, modelSlug]
  );
  const [i, setI] = useState(0);
  useEffect(() => {
    const h = setInterval(() => setI((x) => x + 1), 8000);
    return () => clearInterval(h);
  }, []);
  const o = offers.length ? offers[i % offers.length] : null;
  useEffect(() => { if (o) logPlay(o.kind, o.id, o.title?.en || ""); }, [o, logPlay]);
  if (!o) return null;
  return (
    <div className={inline ? "" : "pointer-events-none absolute bottom-[104px] left-6 z-10 hidden w-[300px] lg:block lg:left-10 pk:!static pk:!mx-auto pk:!mb-2 pk:!block pk:!w-[min(600px,84%,40vh)]"}>
      <AnimatePresence mode="wait">
        <motion.div key={o.id} data-testid="offer-card" initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}>
          <OfferCardView kind={o.kind} kicker={o.local ? t("localKicker") : o.kind === "campaign" ? t("campaignKicker") : t("offerKicker")} title={tx(o.title)} body={tx(o.body)}
            media={o.media?.type === "image" && o.placements?.includes("card") ? o.media : null} />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
